import antdMessage from 'antd/lib/message';
import 'antd/lib/message/style/index';

export default antdMessage;
